export default "__VITE_ASSET__0df96c99__"